import clsx from "clsx";

import { QuestionnaireModel } from "@interfaces/index";
import { FlagPlusSvg, LockOpenSvg, ChecksSvg } from "@components/index";

export const QuestionnaireHeader = ({
  name,
  status,
  statusLabel,
}: {
  name: string;
  status: QuestionnaireModel["status"];
  statusLabel: string;
}) => (
  <div className="flex items-center justify-between">
    <div className="text-400 font-bold text-black-100">{name}</div>
    <div
      className={clsx(
        "flex w-fit items-center gap-x-1 rounded-2xl px-2.5 py-1 text-200 *:size-[18px] *:shrink-0",
        status === "not_started" && "bg-black-4 text-black-32",
        status === "partially_completed" && "bg-primary-104 text-primary-300",
        status === "completed" && "bg-green-8 text-green-100",
      )}
    >
      {status === "not_started" && <FlagPlusSvg />}
      {status === "partially_completed" && <LockOpenSvg />}
      {status === "completed" && <ChecksSvg />}
      {statusLabel}
    </div>
  </div>
);
